var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import CaseAllot from "~/components/distribution-common/case-allot.vue";
import NumberRange from "~/components/common/number-range.vue";
import { CaseAssistAntiFraudCaseStayService } from "~/services/domain-service/case-assist-anti-fraud-case-stay.service.ts";
import { CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import { Getter, namespace } from "vuex-class";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var AllotModule = namespace("case-allot");
var AssistCisitWaitDistribution = /** @class */ (function (_super) {
    __extends(AssistCisitWaitDistribution, _super);
    function AssistCisitWaitDistribution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // @Getter
        // private cheatDepartmentData;
        _this.caseChannel = CASE_CHANNEL.fraud;
        _this.searchModel = {
            areaId: "",
            addressDetail: "",
            overdueDays: {
                max: "",
                min: ""
            },
            overdueAmount: {
                max: "",
                min: ""
            },
            overduePeriod: "",
            customerCategory: "",
            turnSource: "",
            productCategory: "",
            createTime: [],
            productName: "",
            labelName: []
        };
        _this.dataSet = [];
        _this.selectionList = [];
        _this.dialog = {
            ManualDivision: false
        };
        return _this;
    }
    AssistCisitWaitDistribution.prototype.created = function () {
        this.refreshData();
    };
    AssistCisitWaitDistribution.prototype.refreshData = function () {
        var _this = this;
        this.caseAssistAntiFraudCaseStayService
            .queryAntiFraudList(this.searchModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    /**
     * 分案
     */
    AssistCisitWaitDistribution.prototype.manualDivision = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        this.updateCaseIds(this.selectionList.map(function (v) { return v.caseId; }));
        var caseAssistIds = this.selectionList.map(function (v) { return v.id; });
        this.updateExtData({ caseAssistIds: caseAssistIds });
        this.dialog.ManualDivision = true;
    };
    /**
     * 需要手动重置的表单项
     */
    AssistCisitWaitDistribution.prototype.handleResetForm = function () {
        this.searchModel.overdueAmount = { max: "", min: "" };
        this.searchModel.overdueDays = { max: "", min: "" };
        this.searchModel.createTime = { start: "", end: "" };
    };
    /**
     * 进入查看执行页
     */
    AssistCisitWaitDistribution.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.caseId, {
            menuChannel: MENU_CHANNEL.Fraudulent_await,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    __decorate([
        Dependencies(PageService)
    ], AssistCisitWaitDistribution.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AssistCisitWaitDistribution.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseAssistAntiFraudCaseStayService)
    ], AssistCisitWaitDistribution.prototype, "caseAssistAntiFraudCaseStayService", void 0);
    __decorate([
        AllotModule.Mutation
    ], AssistCisitWaitDistribution.prototype, "updateCaseIds", void 0);
    __decorate([
        AllotModule.Mutation
    ], AssistCisitWaitDistribution.prototype, "updateExtData", void 0);
    __decorate([
        Getter
    ], AssistCisitWaitDistribution.prototype, "cheatDepartmentDataNoRoot", void 0);
    AssistCisitWaitDistribution = __decorate([
        Auth(1505),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                CaseAllot: CaseAllot,
                NumberRange: NumberRange
            }
        })
    ], AssistCisitWaitDistribution);
    return AssistCisitWaitDistribution;
}(Vue));
export default AssistCisitWaitDistribution;
